import { SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const ChecklistTemplateForm = ({ loading, onSubmit }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    question: '',
    option_1: '',
    option_1_requires_comments: false,
    option_2: '',
    option_2_requires_comments: false,
  });

  const allFieldsFilled =
    form.question.trim() !== '' &&
    form.option_1.trim() !== '' &&
    form.option_2.trim() !== '';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setForm({ ...form, [name]: checked });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!allFieldsFilled) return;

    if (onSubmit) await onSubmit(form);

    setForm({
      question: '',
      option_1: '',
      option_1_requires_comments: false,
      option_2: '',
      option_2_requires_comments: false,
    });
  };

  return (
    <Form
      onSubmit={handleSubmit}
      className="p-3 border rounded mb-4 bg-light"
    >
      <Form.Group controlId="question" className="mb-3">
        <Form.Label>{t('question')}</Form.Label>
        <Form.Control
          type="text"
          name="question"
          value={form.question}
          onChange={handleChange}
          placeholder={t('enter_question')}
          required
        />
      </Form.Group>

      <Row className="mb-3">
        <Col md={5}>
          <Form.Group controlId="option_1">
            <Form.Label>{t('option_1')}</Form.Label>
            <Form.Control
              type="text"
              name="option_1"
              value={form.option_1}
              onChange={handleChange}
              placeholder={t('enter_option_1')}
              required
            />
          </Form.Group>
        </Col>
        <Col md={2} className="d-flex align-items-end">
          <Form.Group controlId="option_1_requires_comments">
            <Form.Check
              type="checkbox"
              label={t('requires_comments')}
              name="option_1_requires_comments"
              checked={form.option_1_requires_comments}
              onChange={handleCheckboxChange}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={5}>
          <Form.Group controlId="option_2">
            <Form.Label>{t('option_2')}</Form.Label>
            <Form.Control
              type="text"
              name="option_2"
              value={form.option_2}
              onChange={handleChange}
              placeholder={t('enter_option_2')}
              required
            />
          </Form.Group>
        </Col>
        <Col md={2} className="d-flex align-items-end">
          <Form.Group controlId="option_2_requires_comments">
            <Form.Check
              type="checkbox"
              label={t('requires_comments')}
              name="option_2_requires_comments"
              checked={form.option_2_requires_comments}
              onChange={handleCheckboxChange}
            />
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end">
        <SaveButton
          disabled={!allFieldsFilled || loading}
          text={loading ? t('creating') : t('create')}
        />
      </div>
    </Form>
  );
};

export default ChecklistTemplateForm;